/* Stand 2026-09-09: Sticky-Kaufleiste auf allen Breiten, erscheint auch vor dem Kaufbutton. */
/* ==========================================================================
   LAMPE & FORM — Theme-Skript
   Vanilla JS, keine Fremdbibliotheken. Alles progressive enhancement:
   ohne JS bleiben Formulare, Links und Navigation bedienbar.
   ========================================================================== */
(function () {
  'use strict';

  var LAF = window.LAF || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var galleryMobileMQ = window.matchMedia('(max-width: 989px)');

  // Die Galerie springt erst dann auf das Variantenbild, wenn der Kunde selbst
  // eine Variante gewaehlt hat — oder wenn er ueber ?variant=… hereinkommt und
  // damit ausdruecklich eine bestimmte Ausfuehrung meint. Beim gewoehnlichen
  // Seitenaufruf beginnt die Strecke links beim ersten Bild.
  var variantSprungFrei = (function () {
    try { return new URLSearchParams(window.location.search).has('variant'); }
    catch (e) { return /[?&]variant=/.test(window.location.search); }
  })();

  /* ---------------------------------------------------------------- Utils */
  function announce(msg) {
    var el = $('[data-laf-live]');
    if (el) { el.textContent = ''; window.setTimeout(function () { el.textContent = msg; }, 40); }
  }

  function formatMoney(cents) {
    var fmt = LAF.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100);
    function withComma(n, dec) {
      return n.toFixed(dec).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function withPeriod(n, dec) {
      return n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withPeriod(value, 2);
        case 'amount_no_decimals': return withPeriod(value, 0);
        case 'amount_with_comma_separator': return withComma(value, 2);
        case 'amount_no_decimals_with_comma_separator': return withComma(value, 0);
        case 'amount_with_space_separator': return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        case 'amount_no_decimals_with_space_separator': return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        default: return withComma(value, 2);
      }
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])';

  /* --------------------------------------------------- Scroll-Lock/Overlay */
  var scrollY = 0;
  var lockCount = 0;

  function lockScroll() {
    if (lockCount === 0) {
      scrollY = window.scrollY;
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.setAttribute('data-scroll-locked', '');
    }
    lockCount++;
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.removeAttribute('data-scroll-locked');
      // <html> traegt scroll-behavior: smooth — ohne Ausnahme wuerde die Seite nach dem
      // Loesen animiert vom Seitenanfang zur alten Position gleiten (Audit 06.09.).
      var root = document.documentElement, alt = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollY);
      root.style.scrollBehavior = alt;
    }
  }

  function setOverlay(on) {
    var ov = $('[data-laf-overlay]');
    if (!ov) return;
    if (on) {
      ov.hidden = false;
      // Reflow synchron erzwingen, damit die Transition vom Ausgangszustand aus läuft.
      // requestAnimationFrame wäre hier falsch: es pausiert in nicht sichtbaren Tabs,
      // das Overlay bliebe dann dauerhaft unsichtbar.
      void ov.offsetWidth;
      ov.setAttribute('data-open', 'true');
    } else {
      ov.removeAttribute('data-open');
      window.setTimeout(function () { if (!openPanels.length) ov.hidden = true; }, 300);
    }
  }

  /* ------------------------------------------------------ Panel-Verwaltung */
  var openPanels = [];

  function trapFocus(e) {
    var panel = openPanels[openPanels.length - 1];
    if (!panel || e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, panel.el).filter(function (n) {
      return n.offsetParent !== null || n === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openPanel(el, opts) {
    opts = opts || {};
    if (!el || openPanels.some(function (p) { return p.el === el; })) return;
    var entry = { el: el, trigger: document.activeElement, overlay: opts.overlay !== false, lock: opts.lock !== false };
    openPanels.push(entry);
    el.setAttribute('data-open', 'true');
    el.removeAttribute('aria-hidden');
    if (entry.lock) lockScroll();
    if (entry.overlay) setOverlay(true);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.addEventListener('keydown', trapFocus);
    window.setTimeout(function () {
      // 08.09.2026: [data-autofocus] kommt im Markup 0-mal vor; der erste
      // fokussierbare Knoten der Schublade traegt die Aufgabe.
      var focusTarget = $$(FOCUSABLE, el)[0];
      if (focusTarget) focusTarget.focus();
    }, 60);
  }

  function closePanel(el) {
    var idx = -1;
    openPanels.forEach(function (p, i) { if (p.el === el) idx = i; });
    if (idx === -1) return;
    var entry = openPanels.splice(idx, 1)[0];
    el.removeAttribute('data-open');
    el.setAttribute('aria-hidden', 'true');
    if (entry.lock) unlockScroll();
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!openPanels.some(function (p) { return p.overlay; })) setOverlay(false);
    if (!openPanels.length) document.removeEventListener('keydown', trapFocus);
    if (entry.trigger && document.contains(entry.trigger)) entry.trigger.focus();
  }

  function closeTopPanel() {
    if (openPanels.length) closePanel(openPanels[openPanels.length - 1].el);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-laf-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-laf-open'));
      if (target) {
        e.preventDefault();
        if (target.getAttribute('data-open') === 'true') closePanel(target);
        else openPanel(target, { overlay: opener.getAttribute('data-no-overlay') !== 'true' });
      }
      return;
    }
    var closer = e.target.closest('[data-laf-close]');
    if (closer) {
      e.preventDefault();
      var panel = closer.closest('[data-laf-panel]');
      if (panel) closePanel(panel); else closeTopPanel();
      return;
    }
    if (e.target.closest('[data-laf-overlay]')) { closeTopPanel(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openPanels.length) { closeTopPanel(); return; }
      var openMega = $('.laf-nav__item[data-open="true"]');
      if (openMega) { closeMega(openMega); return; }
      var openSearch = $('[data-laf-searchpanel][data-open="true"]');
      if (openSearch) closeSearch();
    }
  });

  /* ------------------------------------------------------------ Mega-Menü */
  var megaTimer = null;
  var desktopMQ = window.matchMedia('(min-width: 990px)');

  function openMega(item) {
    $$('.laf-nav__item[data-open="true"]').forEach(function (o) { if (o !== item) closeMega(o); });
    item.setAttribute('data-open', 'true');
    var btn = item.querySelector('[aria-expanded]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeMega(item) {
    item.removeAttribute('data-open');
    var btn = item.querySelector('[aria-expanded]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function initMega() {
    $$('.laf-nav__item[data-has-mega]').forEach(function (item) {
      var btn = item.querySelector('.laf-nav__link');
      if (!btn) return;

      item.addEventListener('mouseenter', function () {
        if (!desktopMQ.matches) return;
        window.clearTimeout(megaTimer);
        megaTimer = window.setTimeout(function () { openMega(item); }, 150);
      });
      item.addEventListener('mouseleave', function () {
        if (!desktopMQ.matches) return;
        window.clearTimeout(megaTimer);
        megaTimer = window.setTimeout(function () { closeMega(item); }, 180);
      });

      // Tastatur und Touch: umschalten per Klick
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.clearTimeout(megaTimer);
        if (item.getAttribute('data-open') === 'true') closeMega(item); else openMega(item);
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega(item);
      });
    });
  }

  /* ------------------------------------------------- Mobile-Navigation
     08.09.2026: Hier lag ein document-weiter Klicklistener auf
     [data-mobnav-toggle]. Das Attribut kommt in sections, snippets, layout und
     templates 0-mal vor — die mobile Navigation laeuft seit dem Umbau ueber
     natives <details>/<summary> (sections/laf-header.liquid:467, 526).
     Der Listener hat bei jedem Klick auf der Seite ein closest() ausgefuehrt
     und nie etwas gefunden. Entfernt. */

  /* -------------------------------------------------------------- Suche */
  var searchDebounce = null;

  function closeSearch() {
    var panel = $('[data-laf-searchpanel]');
    if (!panel) return;
    panel.removeAttribute('data-open');
    $$('[data-laf-searchtoggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  function initSearch() {
    var panel = $('[data-laf-searchpanel]');
    if (!panel) return;
    var input = panel.querySelector('input[type="search"]');
    var results = panel.querySelector('[data-laf-searchresults]');
    var defaults = panel.querySelector('[data-laf-searchdefault]');

    $$('[data-laf-searchtoggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = panel.getAttribute('data-open') === 'true';
        if (isOpen) { closeSearch(); return; }
        panel.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
        if (input) window.setTimeout(function () { input.focus(); }, 50);
      });
    });

    document.addEventListener('click', function (e) {
      if (panel.getAttribute('data-open') !== 'true') return;
      if (panel.contains(e.target) || e.target.closest('[data-laf-searchtoggle]')) return;
      closeSearch();
    });

    if (!input || !results) return;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(searchDebounce);
      if (q.length < 2) {
        results.innerHTML = '';
        results.hidden = true;
        if (defaults) defaults.hidden = false;
        return;
      }
      searchDebounce = window.setTimeout(function () {
        var url = LAF.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=laf-predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = false;
            if (defaults) defaults.hidden = true;
          })
          .catch(function () { results.hidden = true; if (defaults) defaults.hidden = false; });
      }, 250);
    });
  }

  /* ------------------------------------------------------------ Warenkorb */
  var cartPendingUpdates = 0;
  var cartUpdateQueue = Promise.resolve();
  var cartReloadPending = false;
  var cartLineIdentities = Object.create(null);
  var cartCurrentState = null;
  var cartLastBusy = false;
  var cartLastPending = 0;
  // 15.10.2026 (Handy-Kaufstrecke): Expressknoepfe stehen per Liquid in
  // [data-laf-express] (Drawer-Fuss und /cart). Die Huelle wird waehrend eines
  // Warenkorb-Updates nur per inert gesperrt, nie verschoben.
  var cartWalletSelector = '[data-laf-express], [data-laf-cro-wallet-host], shopify-accelerated-checkout-cart';

  function cartIsBusy() {
    var extras = $('#LafCroCart');
    return cartPendingUpdates > 0 || cartReloadPending || Boolean(extras && extras.getAttribute('aria-busy') === 'true');
  }

  function syncCartGuard() {
    var busy = cartIsBusy();
    $$('[name="checkout"], [data-laf-cro-protection-toggle]').forEach(function (control) {
      if (busy && !control.disabled) {
        control.setAttribute('data-laf-cart-disabled', 'true');
        control.disabled = true;
        control.setAttribute('aria-busy', 'true');
      } else if (!busy && control.hasAttribute('data-laf-cart-disabled')) {
        control.removeAttribute('data-laf-cart-disabled');
        if (!control.hasAttribute('data-laf-cro-disabled')) {
          control.disabled = false;
          control.removeAttribute('aria-busy');
        }
      }
    });
    $$(cartWalletSelector).forEach(function (host) {
      if (busy && !host.hasAttribute('inert')) {
        host.setAttribute('data-laf-cart-inert', 'true');
        host.setAttribute('inert', '');
      } else if (!busy && host.hasAttribute('data-laf-cart-inert')) {
        host.removeAttribute('data-laf-cart-inert');
        host.removeAttribute('inert');
      }
    });
    if (busy !== cartLastBusy || cartPendingUpdates !== cartLastPending) {
      cartLastBusy = busy;
      cartLastPending = cartPendingUpdates;
      document.dispatchEvent(new CustomEvent('laf:cart:busy', {
        detail: { busy: busy, pending: cartPendingUpdates }
      }));
    }
  }

  function announceCartBusy() {
    syncCartGuard();
  }

  function waitForCartExtras() {
    var extras = $('#LafCroCart');
    if (!extras || extras.getAttribute('aria-busy') !== 'true') return Promise.resolve();
    return new Promise(function (resolve) {
      var observer = new MutationObserver(function () {
        if (extras.getAttribute('aria-busy') === 'true') return;
        observer.disconnect();
        resolve();
      });
      observer.observe(extras, { attributes: true, attributeFilter: ['aria-busy'] });
    });
  }

  function rememberCartState(state) {
    cartCurrentState = state;
    state.items.forEach(function (item) {
      var properties = item.properties || {};
      var pairs = Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; });
      var plan = item.selling_plan_allocation;
      cartLineIdentities[item.key] = JSON.stringify([item.variant_id, pairs, plan && plan.selling_plan && plan.selling_plan.id]);
    });
    return state;
  }

  function currentCartKey(key) {
    if (!cartCurrentState || !cartLineIdentities[key]) return key;
    if (cartCurrentState.items.some(function (line) { return line.key === key; })) return key;
    var identity = cartLineIdentities[key];
    var matches = cartCurrentState.items.filter(function (line) { return cartLineIdentities[line.key] === identity; });
    return matches.length === 1 ? matches[0].key : key;
  }

  function readCartState() {
    return fetch(LAF.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error(LAF.strings.cartError);
        return response.json();
      })
      .then(rememberCartState);
  }

  function reloadCartAfterError() {
    cartReloadPending = true;
    announceCartBusy();
    announce(LAF.strings.cartError);
    var drawer = $('#laf-cart-drawer');
    if (drawer && drawer.getAttribute('data-open') === 'true') {
      try { window.sessionStorage.setItem('laf-cro-reopen-cart', '1'); } catch (error) {}
    }
    window.location.reload();
    return new Promise(function () {});
  }

  function runCartUpdate(action) {
    cartPendingUpdates++;
    announceCartBusy();
    var operation = cartUpdateQueue.then(waitForCartExtras).then(readCartState).then(action)
      .catch(function (error) {
        return refreshCartUI().then(function () { throw error; });
      });
    var finished = operation.then(function (result) {
      cartPendingUpdates--;
      announceCartBusy();
      return result;
    }, function (error) {
      cartPendingUpdates--;
      announceCartBusy();
      throw error;
    });
    cartUpdateQueue = finished.catch(function () {});
    return finished;
  }

  document.addEventListener('click', function (event) {
    if (!cartIsBusy()) return;
    var target = event.target.closest('[name="checkout"], [data-laf-cro-protection-toggle], a[href="/checkout"], a[href^="/checkout?"], ' + cartWalletSelector);
    if (target) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (cartIsBusy() && event.target.matches('form[data-cart-static], #LafCartDrawerForm')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  new MutationObserver(syncCartGuard).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'inert', 'aria-busy']
  });

  function refreshCartUI(state) {
    if (!state || !Array.isArray(state.items)) {
      return readCartState().then(refreshCartUI).catch(reloadCartAfterError);
    }
    rememberCartState(state);
    if (state && typeof state.item_count === 'number') {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = state.item_count;
        el.hidden = state.item_count === 0;
        // Die sichtbare Zahl muss im Bedienelementnamen vorkommen, sonst
        // meldet die Prüfung einen Namenskonflikt.
        var btn = el.closest('[data-cart-label]');
        if (btn) {
          var base = btn.getAttribute('data-cart-label');
          btn.setAttribute('aria-label', state.item_count > 0 ? base + ' (' + state.item_count + ')' : base);
        }
      });
      LAF.cartCount = state.item_count;
    }
    // Nur Sections anfordern, die auf DIESER Seite tatsächlich gerendert werden —
    // sonst quittiert die Section Rendering API die ganze Anfrage mit einem Fehler.
    // JSON-Template-Sections MÜSSEN über ihre echte Section-ID (data-section-id,
    // aus {{ section.id }}) angefordert werden — der Dateiname liefert nur
    // Schema-Defaults statt der im Editor gespeicherten Einstellungen.
    var fetchIdFor = function (el) {
      return el.getAttribute('data-section-id') || el.getAttribute('data-section-inner');
    };
    var sections = $$('[data-section-inner]')
      .map(fetchIdFor)
      .filter(function (id, i, arr) { return id && arr.indexOf(id) === i; });
    if (!sections.length) return Promise.resolve();

    var base = window.location.pathname;
    return fetch(base + '?sections=' + sections.map(encodeURIComponent).join(','), { cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error(LAF.strings.cartError);
        return r.json();
      })
      .then(function (data) {
        var replacements = [];
        var focus = null;
        sections.forEach(function (id) {
          var html = data[id];
          if (typeof html !== 'string' || !html.trim()) throw new Error(LAF.strings.cartError);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Eine Section kann in mehrere Teilbereiche zerfallen
          // (data-section-part) — jeder wird mit seinem Gegenstück aus dem
          // frischen HTML abgeglichen. Dazwischenliegende statische Inseln
          // (Express-Buttons) bleiben unberührt.
          $$('[data-section-inner]').forEach(function (current) {
            if (fetchIdFor(current) !== id) return;
            var part = current.getAttribute('data-section-part');
            var sel = part
              ? '[data-section-part="' + part + '"]'
              : '[data-section-inner="' + current.getAttribute('data-section-inner') + '"]';
            var incoming = doc.querySelector(sel);
            if (!incoming) throw new Error(LAF.strings.cartError);
            replacements.push({ current: current, html: incoming.innerHTML });
            var active = document.activeElement;
            var line = active && active.closest('[data-cart-line]');
            if (line && current.contains(active)) {
              focus = {
                region: current,
                key: currentCartKey(line.getAttribute('data-line-key')),
                index: $$('[data-cart-line]', current).indexOf(line),
                selector: active.matches('[data-cart-qty]') ? '[data-cart-qty]'
                  : active.matches('[data-qty-step="1"]') ? '[data-qty-step="1"]'
                  : active.matches('[data-qty-step="-1"]') ? '[data-qty-step="-1"]'
                  : active.matches('[data-cart-remove]') ? '[data-cart-remove]' : null
              };
            }
          });
        });
        replacements.forEach(function (replacement) { replacement.current.innerHTML = replacement.html; });
        syncCartGuard();
        if (focus && focus.selector) {
          var lines = $$('[data-cart-line]', focus.region);
          var targetLine = lines.find(function (line) { return line.getAttribute('data-line-key') === focus.key; })
            || lines[Math.min(focus.index, lines.length - 1)];
          var target = targetLine && ($(focus.selector, targetLine) || $('[data-cart-qty]', targetLine));
          if (!target) target = $('[data-laf-close]', focus.region) || $('.laf-page-head h1');
          if (target) {
            if (!target.matches(FOCUSABLE)) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }
        }
        document.dispatchEvent(new CustomEvent('laf:cart:updated', { detail: { cart: state } }));
      })
      .catch(reloadCartAfterError);
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw new Error(json.description || json.message || LAF.strings.cartError);
        return json;
      });
    });
  }

  function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.setAttribute('data-loading', 'true');
    return runCartUpdate(function () {
      return cartRequest(LAF.routes.cartChange, { id: currentCartKey(key), quantity: quantity })
        .then(function (state) { return refreshCartUI(state); });
    })
      .catch(function (err) { announce(err.message); })
      .then(function () { if (lineEl) lineEl.removeAttribute('data-loading'); });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.laf-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10);
      next = Math.min(max, Math.max(min, next));
      if (String(next) === input.value) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var line = remove.closest('[data-cart-line]');
      changeLine(remove.getAttribute('data-cart-remove'), 0, line);
      return;
    }

    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      // 15.10.2026 (Warenkorb-Upsell): Doppelklick-Sperre, Herkunft als versteckte
      // Eigenschaft _laf_upsell (in der Bestellung messbar), auf /cart kein Drawer.
      if (quickAdd.classList.contains('laf-loading')) return;
      var id = quickAdd.getAttribute('data-quick-add');
      var quelleAttr = quickAdd.getAttribute('data-quick-add-quelle');
      var posten = { id: id, quantity: 1 };
      if (quelleAttr) posten.properties = { _laf_upsell: quelleAttr };
      quickAdd.classList.add('laf-loading');
      runCartUpdate(function () {
        return cartRequest(LAF.routes.cartAdd, { items: [posten] })
          .then(function () { return refreshCartUI(); });
      })
        .then(function () {
          announce(LAF.strings.addedToCart);
          var drawer = $('#laf-cart-drawer');
          var aufCart = document.body.classList.contains('template-cart');
          if (drawer && !aufCart && !openPanels.some(function (p) { return p.el === drawer; })) openPanel(drawer);
        })
        .catch(function (err) { announce(err.message); })
        .then(function () { quickAdd.classList.remove('laf-loading'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = input.closest('[data-cart-line]');
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0, line);
  });

  /* Add-to-Cart per fetch, damit der Drawer ohne Reload aufgeht */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    var drawer = $('#laf-cart-drawer');
    if (!drawer) return; // ohne Drawer normaler POST
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    if (form.getAttribute('data-purchase-pending') === 'true' || (btn && btn.disabled)) return;
    form.setAttribute('data-purchase-pending', 'true');
    var purchaseSection = form.closest('.shopify-section') || document;
    var stickySubmit = purchaseSection.querySelector('[data-sticky-submit]');
    if (stickySubmit) stickySubmit.disabled = true;
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (btn) { btn.classList.add('laf-loading'); btn.setAttribute('aria-disabled', 'true'); }

    var data = new FormData(form);
    data.append('sections', 'laf-cart-drawer');
    runCartUpdate(function () {
      return fetch(LAF.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || LAF.strings.cartError);
          return refreshCartUI();
        });
    })
      .then(function () {
        announce(LAF.strings.addedToCart);
        openPanel(drawer);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.hidden = false; var t = errorEl.querySelector('[data-form-error-text]'); if (t) t.textContent = err.message; }
        else announce(err.message);
      })
      .then(function () {
        form.removeAttribute('data-purchase-pending');
        if (btn) { btn.classList.remove('laf-loading'); btn.removeAttribute('aria-disabled'); }
        updatePurchaseSummary(purchaseSection);
      });
  });

  /* ------------------------------------------------------ Variantenwahl */
  function rememberVariantImageAttributes(img) {
    if (!img || img._lafVariantImageAttributes) return;
    img._lafVariantImageAttributes = {
      sizes: img.getAttribute('sizes'),
      loading: img.getAttribute('loading'),
      fetchpriority: img.getAttribute('fetchpriority')
    };
  }

  function restoreVariantImageAttributes(img) {
    if (!img || !img._lafVariantImageAttributes) return;
    ['sizes', 'loading', 'fetchpriority'].forEach(function (name) {
      var value = img._lafVariantImageAttributes[name];
      if (value === null) img.removeAttribute(name);
      else img.setAttribute(name, value);
    });
  }

  function syncVariantMediaPosition(picker, instant) {
    var section = picker.closest('.shopify-section') || document;
    var gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;

    // 16.10.2026: Hat der Kunde die Galerie schon selbst bewegt (Merker aus
    // snippets/laf-product-gallery.liquid), setzen automatische Aufrufe (Start,
    // load, Drehen des Handys) sie nicht mehr zurueck. Gemessen: Wisch zum Video
    // vor load -> nach load scrollLeft 390 -> 0, Kunde landete wieder auf Bild 1.
    // Nur eine echte Variantenwahl (picker._lafWahlAktiv) darf weiter springen.
    var huelle = gallery.parentElement;
    if (huelle && huelle._lafNutzerBewegt && !picker._lafWahlAktiv) return;

    if (!variantSprungFrei) {
      if (typeof gallery._lafSetGalleryActive === 'function') gallery._lafSetGalleryActive(0);
      if (gallery.scrollLeft) gallery.scrollTo({ left: 0, behavior: 'auto' });
      return;
    }

    var items = $$('.laf-gallery__item:not([hidden])', gallery);
    // 22.10.2026 (Weisung Baran, Lumiere-Vergleich): Rueckfall ist das erste SICHTBARE
    // Bild - der Variantenfilter der Shop-Galerie kann Bild 1 ausblenden.
    var target = gallery.querySelector('.laf-gallery__item[data-variant-active="true"]:not([hidden])') ||
      gallery.querySelector('.laf-gallery__item[data-media-id]:not([hidden])');
    if (!target || !items.length) return;

    if (typeof gallery._lafSetGalleryActive === 'function') {
      gallery._lafSetGalleryActive(Math.max(0, items.indexOf(target)));
    }

    window.requestAnimationFrame(function () {
      // 08.09.2026, ERSTE AENDERUNG: Abstand zum ERSTEN Element statt zur
      // Galerie. Gemessen liefern beide Formeln heute dasselbe
      // (gallery.offsetLeft = 0, Items bei 0, 390, 780 ...), aber sobald die
      // Bahn eine Polsterung oder position: relative bekaeme, laufen sie
      // auseinander. snippets/laf-gallery-thumbs.liquid rechnet bereits so.
      var ziel = target.offsetLeft - items[0].offsetLeft;

      // ZWEITE AENDERUNG: ausserhalb des Sichtfelds wird nicht animiert. Die
      // Bewegung sieht niemand, und ein laufender weicher Bildlauf verschluckt
      // den naechsten Klick.
      var kasten = gallery.getBoundingClientRect();
      var imBild = kasten.bottom > 0 && kasten.top < window.innerHeight;

      if (galleryMobileMQ.matches || gallery.scrollWidth > gallery.clientWidth + 2) {
        gallery.scrollTo({
          left: ziel,
          behavior: (instant || reduceMotion || !imBild) ? 'auto' : 'smooth'
        });
      } else if (gallery.scrollLeft) {
        gallery.scrollTo({ left: 0, behavior: 'auto' });
      }
    });
  }

  function syncDimensionGallery(picker, variantId, target, promoteTarget) {
    var section = picker.closest('.shopify-section') || document;
    var gallery = section.querySelector('[data-gallery]');
    var configEl = gallery && gallery.parentElement.querySelector('[data-laf-dimension-rules]');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (_) { return; }
    var ids = config.map(function (entry) { return String(entry.id); });
    var entry = config.find(function (rule) { return rule.variants.indexOf(String(variantId)) !== -1; });
    var selectedId = entry ? String(entry.id) : '';
    var items = $$('.laf-gallery__item', gallery);
    var photos = [], hidden = [], videos = [], chosen = null;
    items.forEach(function (item) {
      var id = item.getAttribute('data-media-id');
      var dimension = ids.indexOf(id) !== -1;
      item.hidden = dimension && id !== selectedId;
      if (dimension) item.setAttribute('data-laf-dimension', 'true');
      if (item.hidden) hidden.push(item);
      else if (dimension) chosen = item;
      else if (item.classList.contains('laf-gallery__item--ugc')) videos.push(item);
      else photos.push(item);
    });
    photos.sort(function (a, b) { return Number(a.getAttribute('data-laf-base-position')) - Number(b.getAttribute('data-laf-base-position')); });
    if (promoteTarget && photos.indexOf(target) >= 0) photos.unshift(photos.splice(photos.indexOf(target), 1)[0]);
    var ordered = photos.slice();
    if (chosen) ordered.splice(Math.min(2, ordered.length), 0, chosen);
    ordered = ordered.concat(videos, hidden);
    var thumbs = gallery.parentElement.querySelector('[data-gallery-thumbs]');
    var visibleIndex = 0;
    ordered.forEach(function (item) {
      gallery.appendChild(item);
      item.style.order = '0';
      if (item.hidden) item.removeAttribute('data-idx');
      else item.setAttribute('data-idx', String(visibleIndex++));
      if (!thumbs) return;
      var thumb = thumbs.querySelector('[data-thumb-media-id="' + item.getAttribute('data-media-id') + '"]');
      if (!thumb) return;
      var li = thumb.closest('li');
      li.hidden = item.hidden;
      thumb.hidden = item.hidden;
      if (!item.hidden) thumb.setAttribute('data-index', item.getAttribute('data-idx'));
      else thumb.removeAttribute('data-index');
      thumbs.appendChild(li);
    });
    if (typeof gallery._lafRefreshThumbs === 'function') gallery._lafRefreshThumbs();
    if (gallery.getAttribute('data-laf-gallery-dots-ready') === 'true') {
      gallery.removeAttribute('data-laf-gallery-dots-ready');
      initGalleryDots();
    }
  }

  /* ------------------------------------------------------------------
     22.10.2026 (Weisung Baran, Lumiere-Vergleich): Variantenfilter der Shop-Galerie.
     snippets/laf-product-gallery.liquid gibt jedem Bild mit Eintrag in
     laf.galerie_varianten die Regel als data-laf-varianten mit ({"Größe": ["90 × 65 cm"]})
     und blendet fuer die Startvariante schon serverseitig aus. Hier dasselbe bei jedem
     Variantenwechsel: Reihenfolge bleibt, das erste sichtbare Bild ist das Hauptbild,
     Zaehler/Punkte/Miniaturen ziehen nach. Passt kein Foto, bleiben alle sichtbar.
     Rueckgabe true, wenn sich die sichtbare Menge geaendert hat.
  ------------------------------------------------------------------ */
  function galerieVariantenFiltern(picker, variantId) {
    var section = picker.closest('.shopify-section') || document;
    var gallery = section.querySelector('[data-gallery][data-laf-galerie-varianten]');
    if (!gallery || !variantId) return false;
    var variante = (picker._lafVarianten || []).find(function (v) { return String(v.id) === String(variantId); });
    if (!variante) return false;
    var namen;
    try { namen = JSON.parse(gallery.getAttribute('data-laf-optionen') || '[]'); } catch (_) { return false; }
    var alle = $$('.laf-gallery__item', gallery);
    var fotos = alle.filter(function (item) { return !item.classList.contains('laf-gallery__item--ugc'); });
    var soll = new Map();
    fotos.forEach(function (item) {
      var roh = item.getAttribute('data-laf-varianten');
      if (!roh) { soll.set(item, false); return; }
      var regel;
      try { regel = JSON.parse(roh); } catch (_) { soll.set(item, false); return; }
      var passt = Object.keys(regel || {}).every(function (name) {
        var pos = namen.indexOf(name);
        if (pos < 0) return true;
        var werte = Array.isArray(regel[name]) ? regel[name].map(String) : [String(regel[name])];
        return werte.indexOf(String(variante.options[pos])) !== -1;
      });
      soll.set(item, !passt);
    });
    var sichtbar = fotos.filter(function (item) { return !soll.get(item); }).length;
    if (!sichtbar) fotos.forEach(function (item) { soll.set(item, false); });
    var geaendert = false;
    fotos.forEach(function (item) {
      if (item.hidden !== soll.get(item)) { item.hidden = soll.get(item); geaendert = true; }
    });
    if (!geaendert) return false;

    var thumbs = gallery.parentElement.querySelector('[data-gallery-thumbs]');
    var idx = 0, erstes = null;
    alle.forEach(function (item) {
      if (item.hidden) { item.removeAttribute('data-idx'); }
      else { item.setAttribute('data-idx', String(idx++)); if (!erstes) erstes = item; }
      if (!thumbs) return;
      var thumb = thumbs.querySelector('[data-thumb-media-id="' + item.getAttribute('data-media-id') + '"]');
      if (!thumb) return;
      var li = thumb.closest('li');
      if (li) li.hidden = item.hidden;
      thumb.hidden = item.hidden;
    });
    // Das neue Hauptbild sofort laden, nicht erst beim Hineinwischen.
    var erstesBild = erstes && erstes.querySelector('img');
    if (erstesBild && erstesBild.getAttribute('loading') === 'lazy') erstesBild.setAttribute('loading', 'eager');
    if (typeof gallery._lafRefreshThumbs === 'function') gallery._lafRefreshThumbs();
    if (gallery.getAttribute('data-laf-gallery-dots-ready') === 'true') {
      gallery.removeAttribute('data-laf-gallery-dots-ready');
      initGalleryDots();
    }
    return true;
  }

  function activateVariantMedia(picker, mediaId, variantId) {
    var section = picker.closest('.shopify-section') || document;
    var gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;

    // 22.10.2026 (Weisung Baran, Lumiere-Vergleich): erst filtern, dann das Ziel suchen.
    // Bei einer echten Variantenwahl mit geaenderter Bildmenge steht danach das erste
    // sichtbare Bild vorn (beim Laden nicht - dort gilt der Merker _lafNutzerBewegt).
    var gefiltert = galerieVariantenFiltern(picker, variantId);
    if (gefiltert && picker._lafWahlAktiv) {
      if (typeof gallery._lafSetGalleryActive === 'function') gallery._lafSetGalleryActive(0);
      if (gallery.scrollLeft) gallery.scrollTo({ left: 0, behavior: 'auto' });
      if (typeof gallery._lafRefreshThumbs === 'function') gallery._lafRefreshThumbs();
    }

    var items = $$('.laf-gallery__item[data-media-id]', gallery);
    if (!items.length) return;

    var requestedId = mediaId ? String(mediaId) : '';
    var target = requestedId ? items.find(function (item) {
      return item.getAttribute('data-media-id') === requestedId && !item.hidden;
    }) : null;
    var hasVariantMedia = Boolean(target);

    if (!target) target = items.find(function (item) { return !item.hidden; }) || items[0];

    // 14.09.2026, Weisung Baran: das staerkste Bild (erstes Produktmedium)
    // steht beim gewoehnlichen Seitenaufruf auch am Desktop vorn. Vorher zog
    // die CSS-Regel order:-1 das Bild der vorausgewaehlten Variante an Platz 1
    // (gemessen: Empire-Kronleuchter zeigte das alte Lieferantenbild statt des
    // neuen Raumbilds). Die Galerie ordnet sich erst um, wenn der Kunde eine
    // Variante waehlt oder ueber ?variant=... kommt. Die Kaufspalten-Figur
    // [data-laf-varbild] zeigt das Variantenbild weiterhin sofort.
    var galerieUmordnen = hasVariantMedia && variantSprungFrei;

    items.forEach(function (item) {
      var img = item.querySelector('img');
      rememberVariantImageAttributes(img);
      if (galerieUmordnen && item === target) item.setAttribute('data-variant-active', 'true');
      else item.removeAttribute('data-variant-active');

      if (galerieUmordnen && item === target && img) {
        img.setAttribute('sizes', '(min-width: 1600px) 1000px, (min-width: 990px) 66vw, 86vw');
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      } else {
        restoreVariantImageAttributes(img);
      }
    });

    if (galerieUmordnen) gallery.setAttribute('data-variant-media-active', 'true');
    else gallery.removeAttribute('data-variant-media-active');

    syncDimensionGallery(picker, variantId, target, galerieUmordnen);

    // ------------------------------------------------------------------
    // Ausfuehrungsbild in der Kaufspalte mitfuehren (08.09.2026).
    // Weisung: "beim klick auf eine version sofort zum passenden bild
    // geschoben ... ohne dass man danach scrollen muss auf handy."
    // Die Bildquelle steht bereits im Dokument: das passende Galeriebild.
    // Es wird nichts nachgeladen - dieselbe srcset-Kandidatenliste, dieselbe
    // Datei aus dem Zwischenspeicher. Dasselbe Verfahren benutzt
    // snippets/laf-optionsplit.liquid fuer seine Reihenbilder.
    // ------------------------------------------------------------------
    var varbild = section.querySelector('[data-laf-varbild]');
    if (varbild) {
      var vImg = varbild.querySelector('img');
      var quelle = target.querySelector('img');
      var neueQuelle = quelle ? quelle.getAttribute('src') : null;
      // 09.09.2026 (Bau-Brief D, Massnahme 4): Die Quelle wird nur noch
      // uebernommen, wenn die Ausfuehrung ein eigenes Foto hat. Ohne eigenes
      // Foto zeigte die Figur vorher das erste Galeriebild plus den Hinweis
      // "kein eigenes Foto" (268 px vor den Optionen) — jetzt ist sie in dem
      // Fall hidden; die Galerie bleibt das Modellbild. Der Hinweistext
      // (data-laf-varbild-note) existiert nicht mehr.
      if (hasVariantMedia && vImg && neueQuelle && vImg.getAttribute('src') !== neueQuelle) {
        // sizes bleibt unangetastet (100vw aus dem Liquid) - nur die Quelle
        // wandert. width/height bleiben ebenfalls stehen, sonst springt die
        // Hoehe beim Wechsel.
        vImg.setAttribute('srcset', quelle.getAttribute('srcset') || '');
        vImg.setAttribute('src', neueQuelle);
        vImg.setAttribute('alt', quelle.getAttribute('alt') || '');
      }
      varbild.hidden = !hasVariantMedia;
      varbild.setAttribute('data-eigenes-bild', hasVariantMedia ? 'true' : 'false');
    }

    // 08.09.2026: Ohne eigenes Variantenbild wird die Bildbahn NICHT bewegt.
    // Vorher sprang sie kommentarlos auf das Hauptfoto zurueck (gemessen:
    // scrollLeft 1560 -> 0 bei "Schwarz, Oe 80 cm") - also auf ein Bild, das
    // die gewaehlte Ausfuehrung gar nicht zeigt.
    if (hasVariantMedia) syncVariantMediaPosition(picker, false);
  }

  /* ------------------------------------------------------------------
     Selbstkorrektur der Optionswahl (06.09.2026).
     Viele Importprodukte haben ein Scheinraster: die Optionswerte spannen
     Groesse x Farbe x Lichtfarbe auf, es existiert aber nur EINE Variante je
     Groesse. Wer dann Farbe oder Lichtfarbe umstellte, landete auf einer
     Kombination ohne Variante - Kaufbutton tot, Text "Nicht verfuegbar".
     Jetzt bleibt der zuletzt angefasste Wert stehen und die uebrigen Optionen
     ruecken auf die naechstliegende echte Variante nach. Damit ist jede Groesse
     und jede Form jederzeit waehlbar und kaufbar.
  ------------------------------------------------------------------ */
  function variantePassend(variants, selected, geaendert) {
    var beste = null, besteNote = -1;
    variants.forEach(function (v) {
      // Der gerade angefasste Wert ist gesetzt: Varianten ohne ihn kommen nicht in Frage.
      if (geaendert >= 0 && selected[geaendert] !== undefined && v.options[geaendert] !== selected[geaendert]) return;
      var note = 0;
      for (var i = 0; i < v.options.length; i++) {
        if (i === geaendert) continue;
        if (v.options[i] === selected[i]) note += 2;   // moeglichst wenig mit umstellen
      }
      if (v.available) note += 1;                      // bei Gleichstand die kaufbare
      if (note > besteNote) { besteNote = note; beste = v; }
    });
    return beste;
  }

  function auswahlSetzen(picker, v) {
    var geaenderteNamen = [];
    v.options.forEach(function (wert, i) {
      $$('[data-option-index="' + i + '"]', picker).forEach(function (el) {
        if (el.tagName === 'SELECT') {
          if (el.value !== wert) { el.value = wert; geaenderteNamen.push(wert); }
        } else if (el.type === 'radio') {
          if (el.value === wert) { if (!el.checked) { el.checked = true; geaenderteNamen.push(wert); } }
        } else if (el.type === 'hidden') {
          el.value = wert;
        }
      });
    });
    return geaenderteNamen;
  }

  function purchaseTotal(price, quantity, eligible) {
    var rate = eligible ? (quantity >= 3 ? 15 : quantity >= 2 ? 10 : 0) : 0;
    return (price - Math.floor(price * rate / 100)) * quantity;
  }

  function updatePurchaseSummary(section, variant) {
    var box = section.querySelector('[data-purchase-box]');
    if (!box) return;
    var form = box.querySelector('[data-product-form]');
    if (!form) return;
    if (variant !== undefined) {
      box.setAttribute('data-unit-price', variant ? variant.price : 0);
      var title = variant ? (variant.title || (variant.options || []).join(' / ')) : '';
      box.setAttribute('data-variant-title', title !== 'Default Title' ? title : '');
      box.setAttribute('data-variant-available', variant && variant.available ? 'true' : 'false');
    }
    var input = form.querySelector('[name="quantity"]') || document.querySelector('[form="' + form.id + '"][name="quantity"]');
    var quantity = Math.max(1, parseInt(input && input.value, 10) || 1);
    var price = Number(box.getAttribute('data-unit-price')) || 0;
    var available = box.getAttribute('data-variant-available') === 'true';
    var pending = form.getAttribute('data-purchase-pending') === 'true';
    var total = purchaseTotal(price, quantity, box.getAttribute('data-bundle-enabled') === 'true');
    var countText = (LAF.strings.purchaseCount || '__COUNT__ Stück').replace('__COUNT__', quantity);
    var variantText = box.getAttribute('data-variant-title') || '';
    var selection = available ? [variantText, countText].filter(Boolean).join(' · ') : LAF.strings.unavailable;
    $$('[data-purchase-selection]', section).forEach(function (el) { el.textContent = selection; });
    $$('[data-sticky-price]', section).forEach(function (el) {
      el.hidden = !available;
      el.innerHTML = available ? '<span class="laf-price__now">' + formatMoney(total) + '</span>' : '';
    });
    var button = form.querySelector('[data-add-button]');
    if (button) {
      button.disabled = !available;
      button.textContent = available
        ? (LAF.strings.purchaseAction || '__COUNT__ Stück in den Warenkorb').replace('__COUNT__', quantity) + ' · ' + formatMoney(total).replace(/<[^>]*>/g, '')
        : LAF.strings.unavailable;
    }
    var proxy = section.querySelector('[data-sticky-submit]');
    if (proxy) {
      proxy.disabled = !available || pending;
      proxy.textContent = available ? LAF.strings.purchaseShort || 'In den Warenkorb' : LAF.strings.unavailable;
    }
    if (variant) {
      $$('[data-delivery-promise]', section).forEach(function (el) {
        var arrival = el.getAttribute('data-delivery-currency') === 'EUR' && variant.price <= Number(el.getAttribute('data-delivery-price-threshold'));
        el.textContent = el.getAttribute(arrival ? 'data-delivery-arrival' : 'data-delivery-dispatch');
      });
      if (input) {
        if (variant.inventory_management && variant.inventory_policy === 'deny') input.setAttribute('max', Math.max(0, Number(variant.inventory_quantity) || 0));
        else input.removeAttribute('max');
      }
    }
  }

  function initPurchaseSummaries() {
    $$('[data-purchase-box]').forEach(function (box) {
      if (box.getAttribute('data-purchase-ready') === 'true') return;
      box.setAttribute('data-purchase-ready', 'true');
      var section = box.closest('.shopify-section') || document;
      var form = box.querySelector('[data-product-form]');
      if (form) form.addEventListener('change', function () { updatePurchaseSummary(section); });
      $$('[data-purchase-edit]', section).forEach(function (button) {
        button.addEventListener('click', function () {
          var options = document.getElementById(button.getAttribute('aria-controls')) || box;
          options.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          options.focus({ preventScroll: true });
        });
      });
      updatePurchaseSummary(section);
    });
  }

  function updateProductStock(stockEl, variant) {
    if (!stockEl) return;
    var stockCount = variant ? Number(variant.inventory_quantity) : 0;
    var tracked = Boolean(variant && variant.inventory_management);
    var available = Boolean(variant && variant.available);
    var stockState = 'orderable';
    if (!available) stockState = 'out';
    else if (tracked && Number.isFinite(stockCount) && stockCount > 0) stockState = 'in'; // 14.10.2026 (ATC-Umsetzung): nie eine Stueckzahl, 'low' abgeschafft
    stockEl.setAttribute('data-stock-state', stockState);
    stockEl.setAttribute('data-available', available ? 'true' : 'false');
    stockEl.classList.toggle('laf-stock--low', stockState === 'low');
    stockEl.classList.toggle('laf-stock--out', stockState === 'out');
    stockEl.classList.toggle('laf-stock--orderable', stockState === 'orderable');
    var label = !variant ? 'data-label-unavailable' : stockState === 'out' ? 'data-label-sold-out'
      : stockState === 'low' ? 'data-label-low-stock' : stockState === 'in' ? 'data-label-in-stock' : 'data-label-orderable';
    var stockText = stockEl.querySelector('[data-stock-text]') || stockEl.querySelector('span:last-child');
    if (stockText) stockText.textContent = (stockEl.getAttribute(label) || '').replace('__COUNT__', String(stockCount));
  }

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      if (picker.getAttribute('data-laf-variant-ready') === 'true') return;
      picker.setAttribute('data-laf-variant-ready', 'true');

      var section = picker.closest('.shopify-section') || document;
      var form = picker.closest('[data-product-form]');
      var formId = picker.getAttribute('data-form-id');
      if (!form && formId) form = document.getElementById(formId);
      if (!form && section.querySelector) form = section.querySelector('[data-product-form]');
      var scope = form || section;
      var dataEl = document.getElementById(picker.getAttribute('data-variants-id'));
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      // 22.10.2026 (Weisung Baran, Lumiere-Vergleich): fuer den Galerie-Variantenfilter.
      picker._lafVarianten = variants;

      picker.addEventListener('change', function (ereignis) {
        // Welche Option hat der Kunde gerade angefasst? Die bleibt stehen, wenn
        // die Kombination nachgebessert werden muss.
        var geaendert = -1;
        if (ereignis && ereignis.target) {
          var ga = ereignis.target.getAttribute && ereignis.target.getAttribute('data-option-index');
          if (ga !== null && ga !== undefined) geaendert = parseInt(ga, 10);
          if (isNaN(geaendert)) geaendert = -1;
        }
        // Index-treu einsammeln. Einwertige Optionen werden im Picker nicht als
        // Bedienelement gerendert, sondern als verstecktes Feld — ohne sie wuerden
        // die Positionen verrutschen und v.options[i] gegen den falschen Wert
        // pruefen. Das liess bei 9 Produkten gar keine Variante mehr finden:
        // Kaufbutton deaktiviert, Preis eingefroren (gefunden und gefixt 19.08.2026).
        var selected = [];
        $$('input:checked, select, input[type="hidden"][data-option-index]', picker).forEach(function (el) {
          var attr = el.getAttribute('data-option-index');
          var idx = attr === null ? NaN : parseInt(attr, 10);
          if (!isNaN(idx)) selected[idx] = el.value;
        });
        var match = null;
        variants.forEach(function (v) {
          if (match) return;
          var all = true;
          v.options.forEach(function (opt, i) { if (opt !== selected[i]) all = false; });
          if (all) match = v;
        });

        // Keine Variante zu dieser Kombination: die uebrigen Optionen nachruecken
        // lassen, statt den Kunden auf einem toten Kaufbutton stehen zu lassen.
        if (!match) {
          var ersatz = variantePassend(variants, selected, geaendert);
          if (ersatz) {
            var umgestellt = auswahlSetzen(picker, ersatz);
            selected = ersatz.options.slice();
            match = ersatz;
            if (umgestellt.length) announce('Ausfuehrung angepasst: ' + umgestellt.join(', '));
          }
        }

        // Sichtbare Auswahlwerte aktualisieren
        $$('[data-option-value-for]', picker).forEach(function (label) {
          var idx = parseInt(label.getAttribute('data-option-value-for'), 10);
          if (selected[idx] !== undefined) label.textContent = selected[idx];
        });

        var idInput = scope.querySelector('[data-variant-id]');
        var addBtn = scope.querySelector('[data-add-button]');
        // Anzeige-Elemente liegen NICHT zwingend im <form>: in der Buybox ist
        // .laf-buybox__price ein Geschwister des Formulars. Ohne Fallback auf die
        // Section blieb der Preis beim Variantenwechsel stehen (Fix 19.08.2026).
        var priceEl = scope.querySelector('[data-price-target]') || section.querySelector('[data-price-target]');
        var skuEl = scope.querySelector('[data-sku-target]') || section.querySelector('[data-sku-target]');
        var stockEl = scope.querySelector('[data-stock-target]') || section.querySelector('[data-stock-target]');

        if (!match) {
          if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = LAF.strings.unavailable; }
          updateProductStock(stockEl, null);
          updatePurchaseSummary(section, null);
          activateVariantMedia(picker, 0);
          return;
        }
        if (idInput) idInput.value = match.id;
        if (addBtn) {
          if (match.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-label-add'); }
          else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = LAF.strings.soldOut; }
        }
        if (priceEl) {
          var html = '<span class="laf-price__now">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s class="laf-price__was">' + formatMoney(match.compare_at_price) + '</s>';
            // Ersparnis mitziehen. Ohne das bliebe die Zahl aus dem Liquid stehen und
            // waere nach einem Variantenwechsel schlicht falsch (19.08.2026).
            // 22.10.2026 (Weisung Baran, Lumiere-Vergleich): dieselbe Zeile rendert jetzt
            // auch snippets/laf-price.liquid beim Laden (gleiches Element, gleiches Format).
            var ersparnis = match.compare_at_price - match.price;
            html += '<span class="laf-price__save" data-save-target>Sie sparen ' +
              formatMoney(ersparnis) + ' · −' + Math.round(ersparnis * 100 / match.compare_at_price) + ' %</span>';
            priceEl.classList.add('laf-price--sale');
          } else {
            priceEl.classList.remove('laf-price--sale');
          }
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = match.sku || '';
        // 22.10.2026 (Weisung Baran, Lumiere-Vergleich): Lichtstrom je Variante (laf.lumen)
        // in den Technischen Angaben mitfuehren; ohne Wert verschwindet die Zeile.
        $$('[data-laf-lumen-zeile]', section).forEach(function (zeile) {
          var werte;
          try { werte = JSON.parse(zeile.getAttribute('data-laf-lumen-werte') || '{}'); } catch (_) { werte = {}; }
          var lm = Number(werte[String(match.id)]) || 0;
          var zelle = zeile.querySelector('[data-laf-lumen]');
          if (lm > 0 && zelle) zelle.textContent = String(Math.round(lm)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lm';
          zeile.hidden = !(lm > 0);
        });
        // 22.10.2026 (fix-1): Kam der Kunde per ?variant= auf eine Variante mit anderer
        // Lichtfarbe als der festen (anderer Preis als der Warmweiss-Zwilling), nennt die
        // Lichtzeile deren Wert. Traegt die neue Variante den festen Wert, gilt wieder die
        // feste Fassung aus dem Liquid (Name, Text, Kelvinzeile).
        $$('[data-laf-licht-zeile], [data-laf-licht-k-zeile]', section).forEach(function (zeile) {
          var li = parseInt(zeile.getAttribute('data-laf-licht-index'), 10);
          if (isNaN(li) || !match.options || String(match.options[li]) !== zeile.getAttribute('data-laf-licht-fest')) return;
          if (zeile.hasAttribute('data-laf-licht-k-zeile')) { zeile.hidden = false; return; }
          var th = zeile.querySelector('th'), td = zeile.querySelector('td');
          if (th) th.textContent = zeile.getAttribute('data-laf-licht-name-fest') || th.textContent;
          if (td) td.textContent = zeile.getAttribute('data-laf-licht-text-fest') || td.textContent;
        });
        updateProductStock(stockEl, match);
        updatePurchaseSummary(section, match);

        // Zugehöriges Bild als Hauptmotiv aktivieren. Ohne exakte Zuordnung
        // fällt die Galerie bewusst auf das reguläre erste Produktbild zurück.
        // Ab jetzt darf die Galerie mitspringen — der Kunde hat gewählt.
        variantSprungFrei = true;
        picker._lafWahlAktiv = true;
        try { activateVariantMedia(picker, match.featured_media_id, match.id); } finally { picker._lafWahlAktiv = false; }

        if (window.history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      });

      var initialIdInput = scope.querySelector('[data-variant-id]');
      var initialVariant = initialIdInput ? variants.find(function (variant) {
        return String(variant.id) === String(initialIdInput.value);
      }) : null;
      if (initialVariant) updateProductStock(section.querySelector('[data-stock-target]'), initialVariant);
      activateVariantMedia(picker, initialVariant && initialVariant.featured_media_id, initialVariant && initialVariant.id);
      // 22.10.2026 (fix-1): Hat das Liquid bei ?variant= auf den Zwilling mit fester
      // Lichtfarbe und gleichem Preis umgestellt (snippets/laf-warmweiss-standard), steht in
      // der Adresse noch die verlinkte Variante. Sie wird auf die Formular-Variante gesetzt,
      // damit Neuladen, Teilen und Chat dieselbe Ausfuehrung meinen. Nur wenn die Adresse
      // schon eine Variante DIESES Produkts nennt; ohne ?variant= bleibt sie unberuehrt.
      if (initialVariant && window.history.replaceState) {
        try {
          var startUrl = new URL(window.location.href);
          var urlVariante = startUrl.searchParams.get('variant');
          if (urlVariante && urlVariante !== String(initialVariant.id) &&
              variants.some(function (v) { return String(v.id) === urlVariante; })) {
            startUrl.searchParams.set('variant', String(initialVariant.id));
            window.history.replaceState(window.history.state, '', startUrl.toString());
          }
        } catch (_) {}
      }
    });
  }

  function syncAllVariantMediaPositions() {
    $$('[data-variant-picker]').forEach(function (picker) {
      syncVariantMediaPosition(picker, true);
    });
  }

  if (galleryMobileMQ.addEventListener) galleryMobileMQ.addEventListener('change', syncAllVariantMediaPositions);
  else if (galleryMobileMQ.addListener) galleryMobileMQ.addListener(syncAllVariantMediaPositions);
  window.addEventListener('load', syncAllVariantMediaPositions, { once: true });

  /* -------------------------------------------------- Galerie-Indikatoren */
  function initGalleryDots() {
    var CHEVRON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    var CHEVRON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

    $$('[data-gallery]').forEach(function (gallery) {
      if (gallery.getAttribute('data-laf-gallery-dots-ready') === 'true') return;
      var dotsWrap = gallery.parentElement && gallery.parentElement.querySelector('[data-gallery-dots]');
      if (!dotsWrap) return;
      gallery.setAttribute('data-laf-gallery-dots-ready', 'true');
      if (gallery._lafGalleryObserver) gallery._lafGalleryObserver.disconnect();
      var items = $$('.laf-gallery__item:not([hidden])', gallery);
      if (items.length < 2) { dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;

      var current = 0;
      function goTo(i) {
        i = Math.max(0, Math.min(items.length - 1, i));
        gallery.scrollTo({ left: items[i].offsetLeft - gallery.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      // Ab sieben Bildern passen keine sieben 44px-Ziele mehr nebeneinander —
      // auf 320px wären das 308px allein für die Punkte. Dann zeigt die Leiste
      // eine Zählanzeige mit zwei vollwertigen Schaltflächen.
      var counterMode = items.length > 6;
      var dots = [];
      var countEl = null;
      var prevBtn = null;
      var nextBtn = null;

      if (counterMode) {
        var labelPrev = dotsWrap.getAttribute('data-label-prev') || 'Vorheriges Bild';
        var labelNext = dotsWrap.getAttribute('data-label-next') || 'Nächstes Bild';
        dotsWrap.setAttribute('data-mode', 'counter');
        dotsWrap.removeAttribute('role');
        dotsWrap.innerHTML =
          '<button type="button" class="laf-gallery-nav" data-gallery-prev aria-label="' + labelPrev + '">' + CHEVRON_L + '</button>' +
          '<span class="laf-gallery-count" data-gallery-count aria-live="polite">1 / ' + items.length + '</span>' +
          '<button type="button" class="laf-gallery-nav" data-gallery-next aria-label="' + labelNext + '">' + CHEVRON_R + '</button>';
        prevBtn = dotsWrap.querySelector('[data-gallery-prev]');
        nextBtn = dotsWrap.querySelector('[data-gallery-next]');
        countEl = dotsWrap.querySelector('[data-gallery-count]');
        prevBtn.addEventListener('click', function () { goTo(current - 1); });
        nextBtn.addEventListener('click', function () { goTo(current + 1); });
      } else {
        dotsWrap.removeAttribute('data-mode');
        dotsWrap.innerHTML = items.map(function (_, i) {
          return '<button type="button" aria-label="' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>';
        }).join('');
        dots = $$('button', dotsWrap);
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { goTo(i); });
        });
      }

      function setActive(idx) {
        current = idx;
        if (counterMode) {
          countEl.textContent = (idx + 1) + ' / ' + items.length;
          prevBtn.disabled = idx === 0;
          nextBtn.disabled = idx === items.length - 1;
        } else {
          dots.forEach(function (d, i) {
            if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
          });
        }
      }
      gallery._lafSetGalleryActive = setActive;
      var variantActive = gallery.querySelector('.laf-gallery__item[data-variant-active="true"]');
      var initialIndex = variantActive ? items.indexOf(variantActive) : 0;
      if (!variantActive) {
        var nearestDistance = Infinity;
        items.forEach(function (item, index) {
          var distance = Math.abs(item.offsetLeft - items[0].offsetLeft - gallery.scrollLeft);
          if (distance < nearestDistance) { nearestDistance = distance; initialIndex = index; }
        });
      }
      setActive(initialIndex < 0 ? 0 : initialIndex);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!galleryMobileMQ.matches) return;
          var visible = entries.filter(function (entry) { return entry.intersectionRatio > 0.6; });
          if (!visible.length) return;
          visible.sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
          setActive(items.indexOf(visible[0].target));
        }, { root: gallery, threshold: [0.6] });
        gallery._lafGalleryObserver = io;
        items.forEach(function (it) { io.observe(it); });
      }
    });
  }

  /* --------------------------------------------------------------- Rails */
  function initRails() {
    $$('[data-rail]').forEach(function (rail) {
      var wrap = rail.closest('[data-rail-wrap]');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (!prev || !next) return;

      function step() {
        var first = rail.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        if (max <= 2) { prev.hidden = true; next.hidden = true; }
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------------------------- Sticky ATC */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    if (!bar || !('IntersectionObserver' in window)) return;
    // Redesign 07.09.2026: Beobachtet wird der Kaufbutton selbst, nicht mehr
    // der Anker ueber dem Formular. Die Leiste erscheint erst, wenn der Button
    // vollstaendig nach oben aus dem Bild gescrollt ist, und verschwindet,
    // sobald er wieder sichtbar wird. Vorher blendete der Anker mit
    // rootMargin -100 % die Leiste schon ein, solange der Button noch im
    // unteren Bildbereich stand.
    var anchor = $('[data-add-button]') || $('[data-atc-anchor]');
    if (!anchor) return;
    // Der Observer allein reicht nicht: springt die Seite ueber den Button
    // hinweg (Anker, Scroll-Wiederherstellung beim Zurueck), gibt es keinen
    // Schnittwechsel und damit keinen Aufruf — die Leiste bliebe verborgen.
    // Deshalb zusaetzlich eine Pruefung je Bildaufbau beim Scrollen.
    // 09.09.2026: Die Leiste erscheint jetzt AUCH, solange der Kaufbutton noch
    // weit unter der Falz liegt — vorher half sie erst, nachdem man ihn schon
    // passiert hatte. Gemessen sind es bis dahin mobil 748 px und auf dem
    // Desktop 1.071 px bis zum Button; genau diese Strecke soll sie ueberbruecken.
    //
    // Die Sorge vom 07.09. bleibt dabei beruecksichtigt: damals blendete ein
    // Anker mit rootMargin -100 % die Leiste schon ein, waehrend der Button noch
    // im unteren Bildbereich stand — die Leiste lag dann ueber dem echten
    // Button. Das kann hier nicht passieren, weil "unter der Falz" streng
    // gemeint ist (r.top > Fensterhoehe, also gar nicht sichtbar).
    //
    // Zusaetzlich eine halbe Bildschirmhoehe Karenz, damit der erste Eindruck
    // (Galerie, Titel) frei bleibt und die Leiste nicht schon bei Scrollstand 0
    // ueber dem Aufmacherbild liegt.
    var ticking = false;
    function pruefe() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var gescrollt = (window.pageYOffset || document.documentElement.scrollTop || 0) > vh * 0.5;
      var darueber = r.bottom < 0;              // Button oben aus dem Bild
      var darunter = r.top > vh && gescrollt;   // Button noch komplett unter der Falz
      bar.setAttribute('data-visible', r.height > 0 && (darueber || darunter) ? 'true' : 'false');
    }
    var io = new IntersectionObserver(function () { pruefe(); }, { threshold: 0 });
    io.observe(anchor);
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(pruefe);
    }, { passive: true });
    pruefe();

    var proxy = bar.querySelector('[data-sticky-submit]');
    if (proxy) {
      proxy.addEventListener('click', function (e) {
        e.preventDefault();
        var form = $('[data-product-form]');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* --------------------------------------------------- Facetten / Filter */
  function initFacets() {
    var container = $('[data-facets-container]');
    if (!container) return;

    function applyForm(form, pushState) {
      var params = new URLSearchParams(new FormData(form));
      // Leere Werte entfernen, damit die URL lesbar bleibt
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var url = window.location.pathname + (clean.toString() ? '?' + clean.toString() : '');
      loadResults(url, pushState);
    }

    function loadResults(url, pushState) {
      var grid = $('[data-collection-results]');
      if (grid) grid.classList.add('laf-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + container.getAttribute('data-section-id'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-collection-results]', '[data-facets-desktop]', '[data-facets-drawer-inner]', '[data-active-filters]', '[data-result-count]'].forEach(function (sel) {
            var incoming = doc.querySelector(sel);
            var current = $(sel);
            if (incoming && current) current.innerHTML = incoming.innerHTML;
          });
          if (pushState !== false) window.history.pushState({ facets: true }, '', url);
          var results = $('[data-collection-results]');
          if (results) results.classList.remove('laf-loading');
          var anchor = $('[data-results-anchor]');
          if (anchor) {
            var top = anchor.getBoundingClientRect().top + window.scrollY - 120;
            if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        })
        .catch(function () { window.location.href = url; });
    }

    container.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facet-form]');
      if (!form) return;
      applyForm(form, true);
    });

    container.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-facet-form]');
      if (!form) return;
      e.preventDefault();
      applyForm(form, true);
    });

    container.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      loadResults(link.getAttribute('href'), true);
    });

    window.addEventListener('popstate', function () { loadResults(window.location.href, false); });
  }

  /* ------------------------------------------------ Zuletzt angesehen */
  var RV_KEY = 'laf:recently-viewed';

  function trackRecentlyViewed() {
    var meta = $('[data-recently-viewed-track]');
    if (!meta) return;
    var handle = meta.getAttribute('data-recently-viewed-track');
    if (!handle) return;
    var list = [];
    try { list = JSON.parse(window.localStorage.getItem(RV_KEY) || '[]'); } catch (err) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 12);
    try { window.localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (err) { /* Speicher voll oder gesperrt */ }
  }

  function renderRecentlyViewed() {
    var host = $('[data-recently-viewed]');
    if (!host) return;
    var exclude = host.getAttribute('data-exclude') || '';
    var list = [];
    try { list = JSON.parse(window.localStorage.getItem(RV_KEY) || '[]'); } catch (err) { list = []; }
    list = list.filter(function (h) { return h !== exclude; }).slice(0, parseInt(host.getAttribute('data-limit') || '4', 10));
    if (!list.length) return;

    var q = list.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch(LAF.routes.search + '?type=product&q=' + encodeURIComponent(q) + '&section_id=' + host.getAttribute('data-section-id'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-recently-viewed-results]');
        var target = host.querySelector('[data-recently-viewed-results]');
        if (incoming && target && incoming.children.length) {
          target.innerHTML = incoming.innerHTML;
          host.hidden = false;
        }
      })
      .catch(function () { /* Sektion bleibt ausgeblendet */ });
  }

  /* -------------------------------------------------- Sanftes Einblenden
     08.09.2026 entfernt. R3 hat die Einblendanimation am 07.09. global
     abgeschaltet („der eine Bewegungsmoment ist die Story"); der
     IntersectionObserver lief seitdem ueber Elemente, die ohnehin auf
     opacity 1 standen (gemessen: 4 auf der Startseite). Mit der Regel im
     Stylesheet ist auch der Beobachter weg. Die Bewertungswand blendet ueber
     ihre eigene Klasse ein (assets/laf.css, R8). */

  /* ------------------------------------------------- Versandfortschritt */
  function initFreeShip() {
    $$('[data-freeship]').forEach(function (el) {
      var total = parseInt(el.getAttribute('data-cart-total') || '0', 10);
      var threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
      if (!threshold) { el.hidden = true; return; }
      var fill = el.querySelector('.laf-freeship__fill');
      if (fill) fill.style.setProperty('--progress', Math.min(1, total / threshold).toFixed(3));
    });
  }

  /* ------------------------------------------- Header über dem Hero */
  function initHeaderOver() {
    var header = $('.laf-header--over');
    if (!header) return;
    var threshold = 40;

    // 08.09.2026: Hier wurde die Hoehe von .laf-announce gemessen und als
    // --announce-h gesetzt. Die Klasse gibt es seit dem Redesign nicht mehr
    // (die Leiste heisst .laf-streifen), die Variable war in der Vorschau leer,
    // und im Stylesheet liest sie niemand mehr. Messung, resize-Listener und
    // ResizeObserver sind entfallen; geblieben ist der Scroll-Zustand.
    function update() {
      header.setAttribute('data-scrolled', window.scrollY > threshold ? 'true' : 'false');
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ------------------------------------------------ Bewegtbild im Hero */
  function initHeroVideo() {
    $$('[data-laf-video]').forEach(function (video) {
      // Bei reduzierter Bewegung bleibt es beim Posterbild.
      if (reduceMotion) { video.remove(); return; }

      var wrap = video.closest('[data-video-wrap]') || video.parentElement;
      var toggle = wrap && wrap.querySelector('[data-video-toggle]');

      function markPlaying() { video.setAttribute('data-playing', 'true'); }
      video.addEventListener('playing', markPlaying);
      if (!video.paused && video.readyState > 2) markPlaying();

      // Erst laden, wenn der Hero wirklich sichtbar ist — spart Daten
      // auf allen Seiten, auf denen er nie in den Blick kommt.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
              var p = video.play();
              if (p && p.catch) p.catch(function () { /* Autoplay unterbunden — Poster bleibt */ });
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.15 });
        io.observe(video);
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            toggle.setAttribute('data-state', 'playing');
            toggle.setAttribute('aria-label', toggle.getAttribute('data-label-pause') || 'Pause');
          } else {
            video.pause();
            toggle.setAttribute('data-state', 'paused');
            toggle.setAttribute('aria-label', toggle.getAttribute('data-label-play') || 'Abspielen');
          }
        });
      }
    });
  }

  /* --------------------------------------------- Rail-Fortschrittslinie */
  function initRailProgress() {
    $$('[data-rail-progress]').forEach(function (bar) {
      var railId = bar.getAttribute('data-rail-progress');
      var rail = railId ? document.getElementById(railId) : bar.closest('[data-rail-wrap]');
      if (rail && rail.hasAttribute && !rail.hasAttribute('data-rail') && rail.querySelector) {
        rail = rail.querySelector('[data-rail], [data-band-rail]') || rail;
      }
      if (!rail) return;
      var seg = bar.querySelector('.laf-railprogress__bar');
      if (!seg) return;

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 2) { bar.hidden = true; return; }
        bar.hidden = false;
        var ratio = rail.clientWidth / rail.scrollWidth;
        var pos = rail.scrollLeft / max;
        seg.style.setProperty('--seg', (ratio * 100).toFixed(2) + '%');
        // Position in Prozent der eigenen Breite, damit translateX korrekt greift
        seg.style.setProperty('--pos', ((pos * (1 - ratio) * 100) / ratio).toFixed(2) + '%');
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------- Welt-Umschalter mobile Navigation */
  function initWorldSwitch() {
    $$('[data-world-switch]').forEach(function (nav) {
      var buttons = $$('[data-world-target]', nav);
      // Die beiden Welt-Panels sind Geschwister der Reiterzeile, nicht deren
      // Kinder. Deshalb muss die Suche auf die gesamte mobile Navigation
      // begrenzt werden. Eine Suche innerhalb von `nav` findet kein Panel und
      // ließ beim Klick auf „Spiegel“ weiterhin die Leuchten-Inhalte stehen.
      var scope = nav.closest('.laf-mobnav') || document;
      if (!buttons.length) return;
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-world-target');
          buttons.forEach(function (b) {
            var on = b === btn;
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          $$('[data-world-panel]', scope).forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-world-panel') !== target;
          });
        });
      });
    });

    // Innerhalb einer Welt bleibt genau eine Gruppe offen
    document.addEventListener('click', function (e) {
      var sum = e.target.closest('[data-world-panel] details > summary');
      if (!sum) return;
      var current = sum.parentElement;
      var panel = current.closest('[data-world-panel]');
      if (!panel) return;
      window.setTimeout(function () {
        if (!current.open) return;
        $$('details', panel).forEach(function (d) { if (d !== current) d.open = false; });
      }, 0);
    });
  }

  /* ------------------------------------------------------------- Start */

  /* ------------------------------------------------------------------
     Lichtwirkung (06.09.2026): setzt die Marke auf der Farbskala auf die
     Position der gewaehlten Lichtfarbe. Eine Kelvin-Zahl steht nur dann
     an der Marke, wenn sie im Optionswert belegt ist.
  ------------------------------------------------------------------ */
  var LW_TEXTE = {
    warm: 'gemütliches, leicht gelbliches Licht wie bei einer Glühlampe',
    neutral: 'sachliches, klares Licht ohne Farbstich',
    kalt: 'helles, leicht bläuliches Licht wie Tageslicht',
    umschaltbar: 'Sie schalten zwischen den Lichtfarben um'
  };
  var LW_NAMEN = { warm: 'Warmweiß', neutral: 'Neutralweiß', kalt: 'Tageslicht' };
  var LW_STANDARD = { warm: 18, neutral: 50, kalt: 84 };

  function lwPosition(eintrag) {
    var k = eintrag.k;
    if (eintrag.k && eintrag.kbis) k = (eintrag.k + eintrag.kbis) / 2;
    if (!k) return LW_STANDARD[eintrag.art] || 50;
    var p = ((k - 2200) / (7000 - 2200)) * 100;
    // Nicht bis an den Rand: die Marke traegt ein Etikett, das sonst bei 375 px
    // Breite links oder rechts aus der Karte laeuft.
    return Math.max(14, Math.min(86, p));
  }

  function lwEtikett(eintrag) {
    if (eintrag.k && eintrag.kbis) return eintrag.k + '–' + eintrag.kbis + ' Kelvin';
    if (eintrag.k) return eintrag.k + ' Kelvin';
    return LW_NAMEN[eintrag.art] || '';
  }

  function lwZeichne(box, wert) {
    var marken = box.querySelector('[data-lichtwirkung-marken]');
    var hinweis = box.querySelector('[data-lichtwirkung-hinweis]');
    if (!marken) return;
    var werte;
    try { werte = JSON.parse(box.getAttribute('data-werte') || '[]'); } catch (e) { return; }
    var treffer = null;
    for (var i = 0; i < werte.length; i++) if (werte[i].wert === wert) treffer = werte[i];
    if (!treffer) {
      // Zusammengesetzte Werte wie "Warmweiss ohne Fernbedienung" kommen 1:1 aus
      // der Option; faellt der Vergleich aus, wird ueber den Anfang gesucht.
      for (var j = 0; j < werte.length && !treffer; j++) {
        if (wert && wert.indexOf(werte[j].wert) === 0) treffer = werte[j];
      }
    }
    if (!treffer) treffer = werte[0];
    if (!treffer) return;

    marken.innerHTML = '';
    var liste = treffer.art === 'umschaltbar'
      ? [{ art: 'warm' }, { art: 'neutral' }, { art: 'kalt' }]
      : [treffer];

    liste.forEach(function (e) {
      var m = document.createElement('div');
      m.className = 'laf-lichtwirkung__marke' + (treffer.art === 'umschaltbar' ? ' laf-lichtwirkung__marke--blass' : '');
      m.style.left = lwPosition(e) + '%';
      var s = document.createElement('span');
      s.textContent = lwEtikett(e);
      m.appendChild(s);
      marken.appendChild(m);
    });

    if (hinweis) {
      var text = LW_TEXTE[treffer.art] || '';
      hinweis.textContent = treffer.art === 'umschaltbar'
        ? 'Umschaltbar: ' + text + '.'
        : (LW_NAMEN[treffer.art] || '') + ' — ' + text + '.';
    }
  }

  function initLichtwirkung() {
    $$('[data-lichtwirkung]').forEach(function (box) {
      lwZeichne(box, box.getAttribute('data-gewaehlt'));
      if (box.getAttribute('data-lw-ready') === 'true') return;
      box.setAttribute('data-lw-ready', 'true');
      var section = box.closest('.shopify-section') || document;
      var idx = parseInt(box.getAttribute('data-option-index'), 10);
      section.addEventListener('change', function () {
        var picker = section.querySelector('[data-variant-picker]');
        if (!picker || isNaN(idx)) return;
        var wert = null;
        $$('input:checked, select, input[type="hidden"][data-option-index]', picker).forEach(function (el) {
          var a = el.getAttribute('data-option-index');
          if (a !== null && parseInt(a, 10) === idx) wert = el.value;
        });
        if (wert) lwZeichne(box, wert);
      });
    });
  }


  /* ------------------------------------------------------------------
     Lightbox (06.09.2026): Produktbilder sind antippbar. Vorher taten sie
     nichts — Clarity zaehlte 8,35 % Sitzungen mit toten Klicks. Die Bilder
     laufen in einer Bahn mit Scroll-Snap, Wischen und Pfeiltasten.
  ------------------------------------------------------------------ */
  var lightbox = null;
  var lightboxItems = [];
  var lightboxIndex = 0;

  function lightboxBauen() {
    if (lightbox) return lightbox;
    var el = document.createElement('div');
    el.className = 'laf-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Produktbild vergroessert');
    el.innerHTML =
      '<div class="laf-lightbox__bar">' +
        '<span class="laf-lightbox__count" data-lightbox-count aria-live="polite"></span>' +
        '<span class="laf-lightbox__nav">' +
          '<button type="button" class="laf-lightbox__btn" data-lightbox-prev aria-label="Vorheriges Bild">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
          '<button type="button" class="laf-lightbox__btn" data-lightbox-next aria-label="Naechstes Bild">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
          '<button type="button" class="laf-lightbox__btn" data-lightbox-close aria-label="Schliessen">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</span>' +
      '</div>' +
      '<div class="laf-lightbox__track" data-lightbox-track></div>';
    document.body.appendChild(el);

    var track = el.querySelector('[data-lightbox-track]');
    var countEl = el.querySelector('[data-lightbox-count]');
    var prev = el.querySelector('[data-lightbox-prev]');
    var next = el.querySelector('[data-lightbox-next]');

    function zeige(i, sofort) {
      zoomReset();
      i = Math.max(0, Math.min(lightboxItems.length - 1, i));
      lightboxIndex = i;
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: (sofort || reduceMotion) ? 'auto' : 'smooth' });
      countEl.textContent = (i + 1) + ' / ' + lightboxItems.length;
      prev.disabled = i === 0;
      next.disabled = i === lightboxItems.length - 1;
    }
    el._lafZeige = zeige;

    /* Zoom im Overlay (06.09.2026 abends): Pinch und Doppeltipp vergroessern das Bild
       selbst — nicht die ganze Seite. Vorher lief der Browser-Pinch auf den sichtbaren
       Viewport, und die Seite blieb nach dem Schliessen aufgezogen stehen. */
    var zoom = { s: 1, tx: 0, ty: 0, img: null, base: null };
    var zeiger = {};      // aktive Zeiger: pointerId -> {x, y} relativ zur Bahn
    var pinch = null;     // {dist, s} beim Start einer Zwei-Finger-Geste
    var pan = null;       // {x, y, tx, ty} beim Start eines Ein-Finger-Zugs im Zoom
    var letzterTipp = { t: 0, x: 0, y: 0 };
    var bewegt = false;

    function aktuellesBild() {
      var slide = track.children[lightboxIndex];
      return slide ? slide.querySelector('img') : null;
    }
    function nZeiger() { return Object.keys(zeiger).length; }
    function relativ(e) { var r = track.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function zoomAnwenden(anim) {
      var img = zoom.img;
      if (!img) return;
      if (anim) img.setAttribute('data-anim', ''); else img.removeAttribute('data-anim');
      var aktiv = zoom.s > 1.001;
      img.style.transform = aktiv ? 'translate(' + zoom.tx.toFixed(1) + 'px, ' + zoom.ty.toFixed(1) + 'px) scale(' + zoom.s.toFixed(3) + ')' : '';
      if (aktiv) track.setAttribute('data-zoomed', ''); else track.removeAttribute('data-zoomed');
    }
    function zoomReset() {
      if (zoom.img) { zoom.img.style.transform = ''; zoom.img.removeAttribute('data-anim'); }
      zoom = { s: 1, tx: 0, ty: 0, img: null, base: null };
      pinch = null; pan = null; zeiger = {};
      track.removeAttribute('data-zoomed');
    }
    function zoomZurueck() {
      if (!zoom.img) return;
      zoom.s = 1; klemmen(); zoomAnwenden(true);
      window.setTimeout(zoomReset, 240);
    }
    el._lafZoomReset = zoomReset;
    /* Lage des Bildes ohne Transform (relativ zur Bahn) — einmal je Geste gemessen.
       Der kurze Transform-Wechsel wird nicht gemalt, weil im selben Frame gelesen wird. */
    function basisMessen(img) {
      var t = img.style.transform;
      img.style.transform = '';
      var r = img.getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      img.style.transform = t;
      return { x: r.left - tr.left, y: r.top - tr.top, w: r.width, h: r.height, cw: tr.width, ch: tr.height };
    }
    /* Bild nie aus der Bahn ziehen: groesser als die Bahn -> Kanten bleiben aussen,
       kleiner -> zentriert. */
    function klemmen() {
      var b = zoom.base; if (!b) return;
      var W = b.w * zoom.s, H = b.h * zoom.s;
      zoom.tx = W <= b.cw ? (b.cw - W) / 2 - b.x : Math.min(-b.x, Math.max(b.cw - W - b.x, zoom.tx));
      zoom.ty = H <= b.ch ? (b.ch - H) / 2 - b.y : Math.min(-b.y, Math.max(b.ch - H - b.y, zoom.ty));
    }
    /* Auf sNeu zoomen, der Bildpunkt unter (mx, my) bleibt an Ort und Stelle. */
    function zoomAuf(sNeu, mx, my, anim) {
      var img = aktuellesBild(); if (!img) return;
      if (zoom.img !== img) {
        // Nur das Bild wechseln — nicht zoomReset(), das wuerde die laufende Geste
        // (Zeiger, Pinch) mitloeschen und den Pinch nach dem ersten Move abbrechen.
        if (zoom.img) { zoom.img.style.transform = ''; zoom.img.removeAttribute('data-anim'); }
        zoom = { s: 1, tx: 0, ty: 0, img: img, base: null };
      }
      if (!zoom.base) zoom.base = basisMessen(img);
      sNeu = Math.max(1, Math.min(4, sNeu));
      var b = zoom.base;
      var ux = (mx - b.x - zoom.tx) / zoom.s, uy = (my - b.y - zoom.ty) / zoom.s;
      zoom.s = sNeu;
      zoom.tx = mx - b.x - sNeu * ux; zoom.ty = my - b.y - sNeu * uy;
      klemmen(); zoomAnwenden(anim);
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      zeiger[e.pointerId] = relativ(e);
      bewegt = false;
      if (nZeiger() === 2) {
        var ks = Object.keys(zeiger), a = zeiger[ks[0]], b = zeiger[ks[1]];
        pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: zoom.s };
        pan = null;
      } else if (nZeiger() === 1 && zoom.s > 1.001) {
        pan = { x: zeiger[e.pointerId].x, y: zeiger[e.pointerId].y, tx: zoom.tx, ty: zoom.ty };
      }
      if (pinch || pan) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    track.addEventListener('pointermove', function (e) {
      if (!(e.pointerId in zeiger)) return;
      zeiger[e.pointerId] = relativ(e);
      if (pinch && nZeiger() >= 2) {
        var ks = Object.keys(zeiger), a = zeiger[ks[0]], b = zeiger[ks[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y) || 1;
        bewegt = true;
        zoomAuf(pinch.s * d / pinch.dist, (a.x + b.x) / 2, (a.y + b.y) / 2, false);
      } else if (pan && nZeiger() === 1) {
        var p = zeiger[e.pointerId];
        if (Math.abs(p.x - pan.x) + Math.abs(p.y - pan.y) > 4) bewegt = true;
        zoom.tx = pan.tx + (p.x - pan.x); zoom.ty = pan.ty + (p.y - pan.y);
        klemmen(); zoomAnwenden(false);
      }
    });
    function zeigerEnde(e) {
      if (!(e.pointerId in zeiger)) return;
      var p = zeiger[e.pointerId];
      delete zeiger[e.pointerId];
      if (pinch) {
        if (nZeiger() < 2) { pinch = null; if (zoom.s < 1.15) zoomZurueck(); }
        return;
      }
      if (pan) { pan = null; if (bewegt) return; } // Tipp ohne Bewegung im Zoom zaehlt als Tipp
      // Doppeltipp (auch Doppelklick): zwei Tipps binnen 300 ms nahe beieinander
      if (!bewegt && e.type === 'pointerup') {
        var jetzt = e.timeStamp;
        if (jetzt - letzterTipp.t < 300 && Math.hypot(p.x - letzterTipp.x, p.y - letzterTipp.y) < 30) {
          letzterTipp.t = 0;
          if (zoom.s > 1.001) zoomZurueck(); else zoomAuf(2.5, p.x, p.y, true);
        } else {
          letzterTipp = { t: jetzt, x: p.x, y: p.y };
        }
      }
    }
    track.addEventListener('pointerup', zeigerEnde);
    track.addEventListener('pointercancel', zeigerEnde);
    /* Zweiter Finger oder Zug im Zoom: dem Browser die Geste sofort entziehen, sonst
       beginnt er eine Pan-x-Rolle und bricht die Zeigerereignisse ab. */
    track.addEventListener('touchstart', function (e) { if (e.touches.length >= 2 || zoom.s > 1.001) e.preventDefault(); }, { passive: false });
    track.addEventListener('touchmove', function (e) { if (pinch || pan) e.preventDefault(); }, { passive: false });

    prev.addEventListener('click', function () { zeige(lightboxIndex - 1); });
    next.addEventListener('click', function () { zeige(lightboxIndex + 1); });
    el.querySelector('[data-lightbox-close]').addEventListener('click', lightboxSchliessen);
    el.addEventListener('click', function (e) {
      // Klick neben das Bild schliesst; Klick auf das Bild nicht.
      if (e.target.classList.contains('laf-lightbox__slide') || e.target === track) lightboxSchliessen();
    });
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i !== lightboxIndex && i >= 0 && i < lightboxItems.length) {
        lightboxIndex = i;
        countEl.textContent = (i + 1) + ' / ' + lightboxItems.length;
        prev.disabled = i === 0;
        next.disabled = i === lightboxItems.length - 1;
      }
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (el.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') { e.preventDefault(); lightboxSchliessen(); }
      else if (e.key === 'ArrowLeft') zeige(lightboxIndex - 1);
      else if (e.key === 'ArrowRight') zeige(lightboxIndex + 1);
    });
    lightbox = el;
    return el;
  }

  function lightboxOeffnen(items, start) {
    var el = lightboxBauen();
    if (el.getAttribute('data-open') === 'true') return; // sonst zaehlt lockScroll doppelt und die Seite bleibt eingefroren
    if (el._lafZoomReset) el._lafZoomReset();
    var track = el.querySelector('[data-lightbox-track]');
    lightboxItems = items;
    track.innerHTML = items.map(function (it, i) {
      // Das angetippte Bild und seine Nachbarn sofort laden, der Rest erst beim Wischen.
      var eager = Math.abs(i - start) <= 1;
      return '<div class="laf-lightbox__slide"><img src="' + it.src + '" alt="' + it.alt.replace(/"/g, '&quot;') + '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async"></div>';
    }).join('');
    el._lafTrigger = document.activeElement;
    el.setAttribute('data-open', 'true');
    lockScroll();
    el._lafZeige(start, true);
    var close = el.querySelector('[data-lightbox-close]');
    if (close) close.focus();
  }

  function lightboxSchliessen() {
    if (!lightbox || lightbox.getAttribute('data-open') !== 'true') return;
    lightbox.removeAttribute('data-open');
    if (lightbox._lafZoomReset) lightbox._lafZoomReset();
    unlockScroll();
    if (lightbox._lafTrigger && document.contains(lightbox._lafTrigger)) {
      try { lightbox._lafTrigger.focus({ preventScroll: true }); } catch (err) { lightbox._lafTrigger.focus(); }
    }
  }

  function initLightbox() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (gallery.getAttribute('data-laf-lightbox-ready') === 'true') return;
      gallery.setAttribute('data-laf-lightbox-ready', 'true');
      gallery.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lightbox-open]');
        if (!btn || !gallery.contains(btn)) return;
        e.preventDefault();
        var buttons = $$('[data-lightbox-open]', gallery).filter(function (button) { return !button.closest('.laf-gallery__item').hidden; });
        var items = buttons.map(function (b) {
          var img = b.querySelector('img');
          return { src: b.getAttribute('data-lightbox-src') || (img && img.currentSrc) || '', alt: (img && img.alt) || '' };
        });
        lightboxOeffnen(items, buttons.indexOf(btn));
      });
    });
  }

  /* ------------------------------------------------------------------
     Aufklappbare Kacheln (06.09.2026): <details> bleibt die Grundlage
     (ohne Skript klappt es weiterhin), das Skript animiert nur die Hoehe.
  ------------------------------------------------------------------ */
  function initKacheln() {
    $$('.laf-acc__item').forEach(function (item) {
      if (item.getAttribute('data-laf-kachel-ready') === 'true') return;
      item.setAttribute('data-laf-kachel-ready', 'true');
      var summary = item.querySelector(':scope > summary');
      var body = item.querySelector(':scope > .laf-acc__body');
      if (!summary || !body || reduceMotion || typeof body.animate !== 'function') return;

      summary.addEventListener('click', function (e) {
        if (item.classList.contains('laf-acc__item--animating')) { e.preventDefault(); return; }
        e.preventDefault();
        item.classList.add('laf-acc__item--animating');
        if (item.open) {
          var von = body.offsetHeight;
          var zu = body.animate([{ height: von + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
          zu.onfinish = zu.oncancel = function () {
            item.open = false;
            item.classList.remove('laf-acc__item--animating');
          };
        } else {
          item.open = true;
          var ziel = body.offsetHeight;
          var auf = body.animate([{ height: '0px', opacity: 0 }, { height: ziel + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
          auf.onfinish = auf.oncancel = function () {
            item.classList.remove('laf-acc__item--animating');
          };
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     22.10.2026 (Weisung Baran, Lumiere-Vergleich): Groessenhilfe am Groessenwaehler.
     Markup: snippets/laf-groessenhilfe.liquid (Link [data-laf-gh-open] in der
     Optionszeile, Feld [data-laf-gh] darunter). Mobil (< 750 px) ein Blatt von unten
     mit Abdeckung und Scroll-Sperre, am Rechner ein Feld direkt unter der Optionszeile.
     Barrierefrei: aria-expanded am Link, Fokus wandert in das Feld und bleibt dort
     (Tab-Falle), Escape/Schliessen-Knopf/Abdeckung schliessen, Fokus kehrt zum Link
     zurueck. Die gewaehlte Groesse ist markiert (aria-current) und zieht beim Wechsel mit.
     Delegiert am document, damit Section-Neuladen im Editor nichts doppelt bindet.
  ------------------------------------------------------------------ */
  var ghOffen = null;
  var ghBereit = false;
  var ghBlattMQ = window.matchMedia('(max-width: 749px)');

  function ghMarkieren(gh) {
    var picker = gh.closest('[data-variant-picker]');
    var idx = gh.getAttribute('data-laf-gh-index');
    var wert = null;
    if (picker && idx !== null) {
      var el = picker.querySelector('input[type="radio"][data-option-index="' + idx + '"]:checked') ||
        picker.querySelector('select[data-option-index="' + idx + '"]');
      if (el) wert = el.value;
    }
    $$('[data-laf-gh-wert]', gh).forEach(function (zeile) {
      if (wert !== null && zeile.getAttribute('data-laf-gh-wert') === wert) zeile.setAttribute('aria-current', 'true');
      else zeile.removeAttribute('aria-current');
    });
  }

  function ghSchliessen(fokusZurueck) {
    if (!ghOffen) return;
    var offen = ghOffen;
    ghOffen = null;
    offen.gh.hidden = true;
    offen.gh.classList.remove('laf-gh--blatt', 'laf-gh--feld');
    var feld = offen.gh.querySelector('.laf-gh__feld');
    if (feld) feld.removeAttribute('aria-modal');
    offen.trigger.setAttribute('aria-expanded', 'false');
    if (offen.sperre) unlockScroll();
    if (fokusZurueck !== false && document.contains(offen.trigger)) {
      try { offen.trigger.focus({ preventScroll: true }); } catch (err) { offen.trigger.focus(); }
    }
  }

  function ghOeffnen(trigger) {
    var gh = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!gh) return;
    if (ghOffen) ghSchliessen(false);
    var blatt = ghBlattMQ.matches;
    var feld = gh.querySelector('.laf-gh__feld');
    ghMarkieren(gh);
    gh.classList.add(blatt ? 'laf-gh--blatt' : 'laf-gh--feld');
    if (feld) {
      if (blatt) {
        feld.style.top = '';
        feld.setAttribute('aria-modal', 'true');
      } else {
        // Direkt unter der Optionszeile; .laf-option--gh ist der Bezugsrahmen.
        var kopf = trigger.closest('.laf-option__label') || trigger;
        feld.style.top = (kopf.offsetTop + kopf.offsetHeight + 4) + 'px';
      }
    }
    gh.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    if (blatt) lockScroll();
    ghOffen = { gh: gh, trigger: trigger, sperre: blatt };
    var ziel = gh.querySelector('.laf-gh__zu') || feld;
    if (ziel) { try { ziel.focus({ preventScroll: true }); } catch (err) { ziel.focus(); } }
  }

  function initGroessenhilfe() {
    if (ghBereit) return;
    ghBereit = true;
    document.addEventListener('click', function (e) {
      var ausloeser = e.target.closest && e.target.closest('[data-laf-gh-open]');
      if (ausloeser) {
        e.preventDefault();
        if (ghOffen && ghOffen.trigger === ausloeser) ghSchliessen();
        else ghOeffnen(ausloeser);
        return;
      }
      if (!ghOffen) return;
      if (e.target.closest && e.target.closest('[data-laf-gh-close]')) { ghSchliessen(); return; }
      var feld = ghOffen.gh.querySelector('.laf-gh__feld');
      if (!ghOffen.sperre && feld && !feld.contains(e.target)) ghSchliessen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!ghOffen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); ghSchliessen(); return; }
      if (e.key !== 'Tab') return;
      // 22.10.2026 (Pruefer): Tab-Falle nur im modalen Blatt (Handy); am Desktop schliesst Tab aus dem Feld heraus
      if (!ghOffen.sperre) {
        var feldD = ghOffen.gh.querySelector('.laf-gh__feld');
        window.setTimeout(function () { if (ghOffen && feldD && !feldD.contains(document.activeElement)) ghSchliessen(false); }, 0);
        return;
      }
      var feld = ghOffen.gh.querySelector('.laf-gh__feld');
      if (!feld) return;
      var ziele = $$(FOCUSABLE, feld).filter(function (el) { return el.offsetParent !== null; });
      if (!ziele.length) { e.preventDefault(); feld.focus(); return; }
      var erstes = ziele[0], letztes = ziele[ziele.length - 1];
      if (!feld.contains(document.activeElement)) { e.preventDefault(); erstes.focus(); return; }
      if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    }, true);
    document.addEventListener('change', function (e) {
      if (!(e.target.closest && e.target.closest('[data-variant-picker]'))) return;
      // nach laf.js-Selbstkorrektur der Auswahl markieren
      window.setTimeout(function () { $$('[data-laf-gh]').forEach(ghMarkieren); }, 0);
    });
    var wechsel = function () { if (ghOffen) ghSchliessen(false); };
    if (ghBlattMQ.addEventListener) ghBlattMQ.addEventListener('change', wechsel);
    else if (ghBlattMQ.addListener) ghBlattMQ.addListener(wechsel);
  }

  function sicher(fn) {
    try { fn(); } catch (err) { if (window.console && console.error) console.error('LAF-Modul gescheitert:', err); }
  }

  function init() {
    initHeaderOver();
    initHeroVideo();
    initRailProgress();
    initWorldSwitch();
    initMega();
    initSearch();
    initVariantPickers();
    initPurchaseSummaries();
    // Neue Module (06.09.) abgeschirmt: ein Fehler darin darf Galerie, Sticky-Kaufleiste
    // und Facetten nicht mit in den Abgrund reissen.
    sicher(initLichtwirkung);
    sicher(initLightbox);
    sicher(initKacheln);
    sicher(initGroessenhilfe);
    initGalleryDots();
    window.setTimeout(syncAllVariantMediaPositions, 0);
    initRails();
    initStickyAtc();
    initFacets();
    initFreeShip();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: Sektionen werden neu gerendert, Verhalten neu anbinden
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-gallery]', e.target).forEach(function (gallery) {
      if (gallery._lafGalleryObserver) gallery._lafGalleryObserver.disconnect();
      gallery._lafGalleryObserver = null;
      gallery._lafSetGalleryActive = null;
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var drawer = e.target.querySelector('[data-laf-panel]');
    if (drawer && drawer.id === 'laf-cart-drawer') openPanel(drawer);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var drawer = e.target.querySelector('[data-laf-panel]');
    if (drawer) closePanel(drawer);
  });

  /* ------------------------------------------------------------------
     "Abgebildet" gilt nur, solange oben wirklich das erste Produktbild
     steht. Zwei Faelle heben das auf:
       1. Aufruf mit ?variant=... — dann springt die Galerie auf das
          Variantenbild.
       2. der Kunde waehlt selbst — ab da beschreibt das Wort nicht mehr,
          was oben zu sehen ist.
     Im Rasterlayout schiebt laf.css das Variantenbild nach vorn, sobald
     data-variant-media-active gesetzt ist; auch dann faellt sie weg.
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Passt dazu im Warenkorb (08.09.2026). Holt Shopifys Empfehlungen zum
     ersten Artikel als JSON und baut die Reihen mit denselben Klassen wie
     der Drawer-Cross-Sell; die Knoepfe tragen data-quick-add, das der
     bestehende Klick-Handler oben bereits bedient.
     ------------------------------------------------------------------ */
  (function () {
    var kasten = document.querySelector('[data-cart-passt]');
    if (!kasten) return;
    var rows = kasten.querySelector('[data-cart-passt-rows]');
    var requestVersion = 0;
    if (!rows) return;
    function updateRecommendations(cartState) {
      var version = ++requestVersion;
      kasten.hidden = true;
      rows.innerHTML = '';
      if (!cartState || !Array.isArray(cartState.items)) return;
      var source = cartState.items.find(function (item) {
        return !(item.properties && item.properties._laf_protection)
          && item.handle !== 'priorisierte-ersatzabwicklung' && !item.gift_card;
      });
      if (!source) return;
      var cartProductIds = cartState.items.map(function (item) { return String(item.product_id); });
      var url = kasten.getAttribute('data-url') + '?product_id=' + encodeURIComponent(source.product_id) + '&limit=4&intent=complementary';
      fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        if (version !== requestVersion) return;
        var list = (d && d.products) ? d.products.filter(function (p) {
          return p.available && !p.gift_card && p.handle !== 'priorisierte-ersatzabwicklung'
            && cartProductIds.indexOf(String(p.id)) === -1
            && p.variants && p.variants.some(function (variant) { return variant.available && variant.id; });
        }).slice(0, 1) : [];
        if (!list.length) return;
        var geld = function (cent) {
          var s = (cent / 100).toFixed(2).replace('.', ',');
          return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
        };
        rows.innerHTML = list.map(function (p) {
          var v = p.variants.find(function (variant) { return variant.available && variant.id; });
          var bild = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=112') : '';
          var img = bild ? '<img src="' + bild + '" alt="" width="56" height="56" loading="lazy">' : '';
          var preis = '<span class="laf-price__now">' + geld(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) preis += ' <s class="laf-price__was">' + geld(v.compare_at_price) + '</s>';
          return '<div class="laf-crosssell__row">'
            + '<a class="laf-media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>'
            + '<div><a class="laf-crosssell__name" href="' + p.url + '">' + p.title + '</a><div class="laf-price">' + preis + '</div></div>'
            + (v.id ? '<button type="button" class="laf-crosssell__add" data-quick-add="' + v.id + '">Hinzufügen</button>' : '')
            + '</div>';
        }).join('');
        kasten.hidden = false;
      })
      .catch(function () {});
    }
    document.addEventListener('laf:cart:updated', function (event) {
      updateRecommendations(event.detail && event.detail.cart);
    });
    fetch(LAF.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cartState) { if (requestVersion === 0) updateRecommendations(cartState); })
      .catch(function () {});
  })();

  /* 08.09.2026 abends entfernt: die Auszeichnung verschwand beim ersten
     Variantenwechsel. Das war richtig, solange sie "das ist das gerade
     gezeigte Bild" bedeutete — mit dem Wechsel wurde die Aussage falsch.
     Seit der Weisung "bei der teuersten Version das Empfohlen adden" ist sie
     eine Empfehlung des Haendlers und bleibt richtig, egal was angeklickt
     ist. Sie steht deshalb dauerhaft. */
})();
